import React from 'react';
import { useI18n } from '../context/I18nContext';

/**
 * Aura QR - external QR generator (public URL only), architecture-ready per Prompt 1.
 * Free image API - no auth needed, and only encodes a public /u/{username} URL.
 */
export default function AuraQR({ username }) {
  const { t } = useI18n();
  const publicUrl = `${window.location.origin}/u/${username}`;
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=0&color=00F0FF&bgcolor=0F0F16&data=${encodeURIComponent(publicUrl)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
    } catch (_e) {
      // clipboard denied - fine
    }
  };

  return (
    <div data-testid="aura-qr" className="aura-card p-4 flex items-center gap-4">
      <div className="relative shrink-0 rounded-xl overflow-hidden border border-aura-cyan/40 p-1.5 bg-aura-surface2">
        <img src={qrSrc} alt="Aura QR" className="h-24 w-24 block" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] tracking-[0.2em] font-display text-aura-cyan mb-1">{t('profile.yourQr')}</div>
        <div className="text-xs text-aura-textDim mb-2">{t('profile.scanToView')}</div>
        <div className="flex items-center gap-2">
          <code className="truncate text-[11px] font-mono text-white/70 px-2 py-1 rounded bg-white/5 border border-white/5">/u/{username}</code>
          <button
            type="button"
            onClick={copy}
            data-testid="qr-copy-link"
            className="text-[11px] font-display px-2 py-1 rounded-full border border-white/10 bg-white/5 hover:border-aura-cyan/50"
          >
            {t('profile.copyLink')}
          </button>
        </div>
      </div>
    </div>
  );
}
